import type { Localized } from "@/domain/types";

/** Normalized ISO-style code; persisted values are validated by languageSchema. */
export type Language = string;

export function normalizeLanguage(value: unknown): Language | undefined {
  if (typeof value !== "string") return undefined;
  const code = value.trim().toLowerCase();
  return /^[a-z]{2,3}$/.test(code) ? code : undefined;
}

export function companyLanguageOptions(primaryLanguage: Language): Language[] {
  return primaryLanguage === "en" || primaryLanguage === "he" ? [] : [primaryLanguage, "en"];
}

export function languageLabel(language: Language): string {
  return new Intl.DisplayNames(["en"], { type: "language" }).of(language) ?? language;
}

export function resolveLocalized(value: Localized | undefined, language: Language): string {
  return value?.[language] ?? value?.["en"] ?? value?.["he"] ?? "";
}

/** Derive text only for languages present in the original data. */
export function mapLocalized(value: Localized, transform: (text: string, language: Language) => string): Localized {
  return Object.fromEntries(Object.entries(value).map(([language, text]) => [language, transform(text, language)]));
}
